import React, { useState } from 'react';

import { gql } from '@apollo/client';
import { useAsync } from 'react-use';
import { AlineTextarea } from 'src/components/AlineTextarea';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';
import { useDebouncedCallback } from 'use-debounce';

import { StepLayout } from '../StepLayout';

const useStyles = makeStyles()(_theme => ({
  stepLayout: {
    width: 'inherit',
  },
}));

export function WorkflowCustomEmail({ workflowId }: { workflowId: UUID }) {
  const { classes } = useStyles();

  return (
    <StepLayout className={classes.stepLayout} title="Signature message">
      <CustomEmailForm workflowId={workflowId} />
    </StepLayout>
  );
}

void gql`
  query GetWorkflowMessage($workflowId: UUID!) {
    workflow(workflowId: $workflowId) {
      __typename
      id
      envelopeMsg
    }
  }
`;

export function CustomEmailForm({ workflowId }: { workflowId: UUID }) {
  const [message, setMessage] = useState<string>('');
  const [updateWorkflow] = Apollo.useUpdateWorkflowMutation();
  const [getWorkflowWithMessage] = Apollo.useGetWorkflowMessageLazyQuery({
    fetchPolicy: 'network-only',
  });
  const debouncedUpdateWorkflow = useDebouncedCallback(updateWorkflow, 1000);

  useAsync(async () => {
    const { data } = await getWorkflowWithMessage({ variables: { workflowId } });
    setMessage(data?.workflow?.envelopeMsg ?? '');
  }, [getWorkflowWithMessage, workflowId]);

  return (
    <AlineTextarea
      maxRows={5}
      minRows={5}
      placeholder="Add a message for signers when they receive the workflow..."
      value={message}
      onChange={async e => {
        setMessage(e.target.value);
        await debouncedUpdateWorkflow({
          variables: {
            input: {
              props: {
                envelopeMsg: e.target.value,
              },
              workflowId,
            },
          },
        });
      }}
    />
  );
}
